import script from "./ProjectDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDetails.vue?vue&type=style&index=0&id=3d167603&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d167603"]])

export default __exports__